import { useState } from "react";

const CloseLostModal = ({ isOpen, onClose, onSave }) => {
  const [reason, setReason] = useState("");

  const handleSubmit = () => {
    if (!reason.trim()) {
      alert("Reason is required!");
      return;
    }
    onSave(reason);
    onClose();
    setReason("");
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
      <div className="bg-white rounded p-5 w-1/3">
        <h2 className="text-lg font-bold mb-2">Reason for Close Lost</h2>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Enter reason..."
          className="w-full border p-2 rounded"
        />
        <div className="flex justify-end mt-4">
          <button
            className="mr-2 bg-gray-400 text-white px-4 py-2 rounded"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="bg-danger text-white px-4 py-2 rounded"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default CloseLostModal;
